import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import EditorMoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--editor-more';
import Tooltip from '@atlaskit/tooltip';
import { messages } from '../../shared/i18n';

/**
 * Test id for wrapper button
 */
export var RENDER_SHOWMORE_TESTID = 'show-more-button';
/**
 * Show more custom emojis button
 */
export var ShowMore = function ShowMore(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(FormattedMessage, messages.moreEmoji, function (message) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: message
    }, /*#__PURE__*/React.createElement(IconButton, {
      label: messages.moreEmoji.defaultMessage,
      onClick: onClick,
      testId: RENDER_SHOWMORE_TESTID,
      icon: EditorMoreIcon,
      appearance: "subtle"
    }));
  });
};